import { AxiosPublic } from "../config/axios";

export async function wallImages() {
    return await AxiosPublic.get("wall-image")
        .then(res => res.data.data)
        .catch(err => { alert(err.response?.data.message); return null })
}